import React, { useState } from "react"
import { graphql, navigate } from "gatsby"
import Layout from "@layouts/Layout"
import Image from "gatsby-image"
import { Container, Row, Col, Button } from "react-bootstrap"
import { BsArrowLeft } from "react-icons/bs"
import { IoMdCloseCircle } from "react-icons/io"
import AddToCartButton from "../components/AddToCartButton"

const ProductTemplate = ({
  data: {
    product,
    product: {
      price,
      title,
      category,
      description: { description },
      image: { fluid },
    },
  },
}) => {
  const [successMsg, setSuccessMsg] = useState(false)

  return (
    <Layout>
      <section className="py-6 py-md-8">
        <Container>
          <Button
            onClick={() => navigate(-1)}
            size="sm"
            variant="outline-powder"
            className="mb-4"
          >
            <BsArrowLeft size="1.5em" /> Back to all {category}s
          </Button>

          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <Image fluid={fluid} />
            </Col>

            <Col>
              <h1>
                <u>{title}</u>
              </h1>
              <p>{description}</p>
              <p className="text-powder" style={{ fontSize: "1.3em" }}>
                <b>R{price}</b>
              </p>
              <AddToCartButton
                productData={product}
                successMsg={() => setSuccessMsg(true)}
              />{" "}
              {successMsg && (
                <p className="mt-3 d-inline ml-2 text-powder">
                  Product has been added to your cart!{" "}
                  <span role="img" aria-label="hooray">
                    🥳
                  </span>
                  <IoMdCloseCircle
                    className=" mb-1 ml-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setSuccessMsg(false)}
                  />
                </p>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query GetSingleProduct($slug: String) {
    product: contentfulProduct(slug: { eq: $slug }) {
      price
      title
      category
      description {
        description
      }
      image {
        fluid {
          ...GatsbyContentfulFluid
        }
      }
    }
  }
`

export default ProductTemplate
